import HonoraiosDetalleApi from "../../apis/HonorarioDetalle";

export default {
  namespaced: true,
  state: {
    itemsHonorarios: [],
    file_horarioDetalle: null,
  },
  mutations: {
    set_itemsHonorarios(state, itemsHonorarios) {
      state.itemsHonorarios = itemsHonorarios;
    },
    set_file_honorario_detalle(state, value) {
      state.file_horarioDetalle = value;
    },
  },
  actions: {
    emptyFileHonorarioDetalle({ commit }, value) {
      commit("set_file_honorario_detalle", value);
    },
    async getItemsEmple({ commit, dispatch }, id) {
      return await HonoraiosDetalleApi.getEmpleados(id)
        .then((response) => {
          commit("set_itemsHonorarios", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar registros, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async actualizaEmpleado({ dispatch }, descuento) {
      return await HonoraiosDetalleApi.actualizaDescuento(descuento)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "correcto",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al registrar el descuento.",
          });
        });
    },
    async actualizaEmpleadoBonos({ dispatch }, bono) {
      return await HonoraiosDetalleApi.actualizaBono(bono)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "correcto",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al registrar el descuento.",
          });
        });
    },
    async calculaCierra({ dispatch }, items) {
      return await HonoraiosDetalleApi.calculaCierra(items)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se guardo correctamente",
            },
            { root: true }
          );
          let id = localStorage.getItem("id_recibo");
          dispatch("getItemsEmple", id);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Error al momento de guardar planilla",
          });
        });
    },
    async reabrirHonorario({ dispatch }, items) {
      return await HonoraiosDetalleApi.reabrirHonorario(items)
        .then((response) => {
          if (response.status === 210) {
            dispatch(
              "notifications/store_notification",
              {
                type: "error",
                message: response.data.error || "Recibo Honorario Pagada",
              },
              { root: true }
            );
          } else {
            dispatch(
              "notifications/store_notification",
              {
                type: "success",
                message: "Se reabriero recibo por honorarios correctamente",
              },
              { root: true }
            );
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Error al momento de reabrir recibo por honorarios",
          });
        });
    },
    async reciboDownload({ commit, dispatch }, id) {
      commit("set_file_honorario_detalle", null);

      return await HonoraiosDetalleApi.reciboDownload(id)
        .then((response) => {
          commit("set_file_honorario_detalle", response.data.file_name);
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se descargo el reporte de manera correcta",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al descargar reporte",
          });
        });
    },
    async actualizarReciboHonorario({ commit, dispatch }, id_recibo_honorario) {
      return await HonoraiosDetalleApi.actualizarReciboHonorario(
        id_recibo_honorario
      )
        .then((response) => {
          commit("set_itemsHonorarios", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al actualizar.",
            },
            { root: true }
          );
        });
    },
  },
};
